import React, {Component} from "react"
import {Alert, Modal, ModalBody, ModalHeader,} from "reactstrap";
import PropTypes from "prop-types";

class ApproveRejectModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
        };
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                scrollable={true}
                backdrop={'static'}
                id="staticBackdrop"
            >
                <ModalHeader toggle={this.props.onCancel}>
                    [#{this.props.approve ? this.props.approve.id : ''}] 입장 신청 거절
                </ModalHeader>
                <ModalBody>
                    <Alert color="warning" role="alert">
                        <b>아래 사용자의 레쿠 소통방 입장을 거부할까요?</b>
                        <br/><br/>
                        트위터 닉네임: {this.props.approve ? this.props.approve.twitterName : ''}
                        <br/>
                        트위터 아이디: @{this.props.approve ? this.props.approve.twitterUsername : ''}
                    </Alert>

                    <div>
                        <label htmlFor="reason" className="form-label">사유</label>
                        <input
                            type="text"
                            className="form-control"
                            id="reason"
                            placeholder="사유가 있다면 적어주세요. (요청자에게 거절 사유로 보여집니다)"
                            value={this.state.reason}
                            onChange={e => this.setState({reason: e.target.value})}
                        />
                    </div>
                </ModalBody>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light"
                            onClick={() => this.props.onCancel()}>
                        취소
                    </button>
                    <button type="button" className="btn btn-warning"
                            onClick={() => this.props.onSubmit(this.state.reason)}>
                        입장 신청 거절
                    </button>
                </div>
            </Modal>
        )
    }
}

ApproveRejectModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    approve: PropTypes.object,

    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default ApproveRejectModal;
